import React, { useContext } from "react";
import { CardItemAuthorization } from "../../../components/common/CardItemAuthorization";
import UserContext from "../../../context/user-context";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  markAuthorization,
  toggleAuthorization,
} from "../../../store/actions/userAction";
import { AuthorizationType, GuestType } from "../../../store/types/userTypes";
import { getResidentPassInformation } from "../../../utils/Parses";
import { CompanionTabIndex, EntrantTabIndex } from "../../../utils/tabIndex";
import { CardAuthorization } from "../CardAuthorization/CardAuthorization";

export const AwaitingRequestAuthorization = () => {
  const { state, dispatch } = useContext(UserContext);
  const { t, BundleKey } = useTranslation();

  const handleCheckBoxChange = (
    value: boolean,
    id: string,
    guestType: GuestType
  ) => {
    dispatch(markAuthorization(id, value, AuthorizationType.awaitingRequest));
  };

  const handleToggleChange = (value: GuestType, id: string) => {
    dispatch(toggleAuthorization(id, value, AuthorizationType.awaitingRequest));
  };

  return (
    <>
      {state.authorizations?.length !== 0 &&
      state.authorizations?.find(
        (item) => item.type === AuthorizationType.awaitingRequest
      ) !== undefined ? (
        <CardAuthorization
          title={t(BundleKey.DETAIL_AUTHORIZATION_PENDING_TITLE)}
          type={AuthorizationType.awaitingRequest}
        >
          {state.authorizations.map((pass, index) => {
            if (pass.type === AuthorizationType.awaitingRequest && !pass.hidden)
              return (
                <CardItemAuthorization
                  key={index}
                  id={pass.id}
                  tabIndex={
                    state.config?.companion
                      ? CompanionTabIndex.pendingRequest
                      : EntrantTabIndex.pendingRequest
                  }
                  checkValue={pass.mark}
                  checkHandle={handleCheckBoxChange}
                  toggleTypeValue={pass.guestType}
                  toggleTypeHandle={handleToggleChange}
                >
                  {getResidentPassInformation(
                    pass.authorization.host,
                    pass.authorization.beginDatetime,
                    pass.authorization.endDatetime,
                    pass.authorization
                  )}
                </CardItemAuthorization>
              );
          })}
        </CardAuthorization>
      ) : null}
    </>
  );
};
